import { v4 } from 'uuid';
import { getAuthInstance } from '../services/auth/auth-instance';

let sharedWorker: SharedWorker | null = null;
let tabs: string[] = [];
const id = v4();
type Listener = (tabs: string[]) => void;

const listeners = [] as Listener[];

export function initMultiTabListener() {
    // Chrome on android check
    if (!supportsSharedWorker) {
        return;
    }

    if (sharedWorker) {
        return;
    }

    sharedWorker = new SharedWorker(new URL('./session-count-worker.ts', import.meta.url), { name: 'session-counter', type: 'module' });
    sharedWorker.port.start();

    sharedWorker.port.onmessage = (e) => {
        if (e.data[0] === 'loggedOut') {
            getAuthInstance().logout();
        } else if (e.data[0] === 'tabsChanged') {
            tabs = e.data[1];
            listeners.forEach((x) => x(tabs));
        }
    };

    sharedWorker.port.postMessage(['load', id]);

    // Don't use onbeforeunload because we use it to prompt the user to save changes to the ud view, and if we return true from beforeunload and the users clicks either cancel or ok there's no API to tell us which one they selected
    // Don't use unload because it unreliable
    window.onpagehide = () => {
        sharedWorker?.port.postMessage(['unload', id]);
    };
}

export function removeMultiTabListener() {
    if (sharedWorker?.port) {
        sharedWorker.port.onmessage = null;
    }
    sharedWorker = null;
}

export function sendTabLogout() {
    sharedWorker?.port.postMessage(['logout', id]);
}

export function sendTabLogin() {
    sharedWorker?.port.postMessage(['login', id]);
}

export function getTabs() {
    return tabs;
}

export function getTabId() {
    return id;
}

export function addMultiTabEventListener(listener: Listener) {
    listeners.push(listener);
    return {
        unsubscribe: () => {
            const idx = listeners.indexOf(listener);
            if (idx > -1) {
                listeners.splice(idx, 1);
            }
        }
    };
}

export const supportsSharedWorker = typeof SharedWorker !== 'undefined';
